module.exports = __webpack_public_path__ + "mobile/img/crm-img5.1ed2024d.png";